import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { DateTimeRegion, language as listOfCountry } from '@app/constants';

@Pipe({
  name: 'dateLocale'
})
export class DateLocalePipe implements PipeTransform {

  transform(value: any, format: string, language: string): any {

    const euRegion = listOfCountry.filter(x => x.timeRegion === DateTimeRegion.EU);

    const locale = euRegion.filter(e => e.code === language).length > 0 ? 'uk' : language;

    switch (format) {
      case 'date':
        return formatDate(value, 'mediumDate', locale);
      case 'dateTime' :
        return formatDate(value, 'shortTime', locale)
        + ' ' + formatDate(value, 'mediumDate', locale);
      default:
        return formatDate(value, 'mediumDate', locale);
    }
  }
}
